// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__10-P7","col":"Table_col__1X-Vz","fulfillmentStatus":"Table_fulfillmentStatus__3jC0u","emailCol":"Table_emailCol__1Ztdo"};